export default "__VITE_ASSET__b467a203__"